import React, { useState, useEffect } from 'react';
import { Menu, X, Scale } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 bg-[rgb(var(--bg-primary))] shadow-md transition-all duration-300"
    >
      <nav className="container mx-auto px-6 md:px-12 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div
            onClick={() => scrollToSection('hero')}
            className="flex items-center gap-3 cursor-pointer group"
          >
            <div className="w-12 h-12 flex items-center justify-center">
              <img
                src="https://customer-assets.emergentagent.com/job_661426c8-676a-4387-8d77-4e9e1aa6a517/artifacts/1a2m54ip_Logo%20OH%20%26%20Asociados.png"
                alt="Ochoa Herrera & Asociados"
                className="w-full h-full object-contain"
              />
            </div>
            <span className="text-xl font-semibold font-['Crimson_Text'] text-[rgb(var(--burgundy-primary))]">
              Ochoa Herrera & Asociados
            </span>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('servicios')}
              className="body-regular transition-colors hover:text-[rgb(var(--burgundy-primary))] text-[rgb(var(--text-primary))]"
            >
              Servicios
            </button>
            <button
              onClick={() => scrollToSection('nosotros')}
              className="body-regular transition-colors hover:text-[rgb(var(--burgundy-primary))] text-[rgb(var(--text-primary))]"
            >
              Nosotros
            </button>
            <button
              onClick={() => scrollToSection('faq')}
              className="body-regular transition-colors hover:text-[rgb(var(--burgundy-primary))] text-[rgb(var(--text-primary))]"
            >
              FAQ
            </button>
            <button
              onClick={() => scrollToSection('contacto')}
              className="px-6 py-2.5 border-2 border-[rgb(var(--burgundy-primary))] text-[rgb(var(--burgundy-primary))] hover:bg-[rgb(var(--burgundy-primary))] hover:text-white rounded-none button-text transition-smooth"
            >
              Contacto
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 transition-colors text-[rgb(var(--text-primary))]"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden absolute top-full left-0 right-0 bg-[rgb(var(--bg-primary))] shadow-lg py-6 px-6">
            <div className="flex flex-col gap-4">
              <button
                onClick={() => scrollToSection('servicios')}
                className="body-regular text-[rgb(var(--text-primary))] hover:text-[rgb(var(--burgundy-primary))] text-left transition-colors py-2"
              >
                Servicios
              </button>
              <button
                onClick={() => scrollToSection('nosotros')}
                className="body-regular text-[rgb(var(--text-primary))] hover:text-[rgb(var(--burgundy-primary))] text-left transition-colors py-2"
              >
                Nosotros
              </button>
              <button
                onClick={() => scrollToSection('faq')}
                className="body-regular text-[rgb(var(--text-primary))] hover:text-[rgb(var(--burgundy-primary))] text-left transition-colors py-2"
              >
                FAQ
              </button>
              <button
                onClick={() => scrollToSection('contacto')}
                className="px-6 py-2.5 border-2 border-[rgb(var(--burgundy-primary))] text-[rgb(var(--burgundy-primary))] hover:bg-[rgb(var(--burgundy-primary))] hover:text-white rounded-none button-text transition-smooth text-center"
              >
                Contacto
              </button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
